var map = {
	"./1.png": 1567,
	"./2.png": 1568,
	"./3.png": 1569,
	"./4.png": 1570,
	"./5.png": 1571,
	"./6.png": 1572,
	"./7.png": 1573,
	"./8.png": 1574
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1566;